import { defineStore } from 'pinia';
import ViajesGrupoApiService from '../services/api/skiandnight/ViajesGrupoApiService';
export const viajesGrupos = defineStore('viajesGrupos', {
  state: () => ({
    resumenViajes: null,
    viajeSeleccionado: null,
  }),
  getters: {
    getResumenViajes(state) {
      return state.resumenViajes || [];
    },
    getViajeSeleccionado(state) {
      return state.viajeSeleccionado;
    },
  },
  actions: {
    async fetchResumenViajes() {
      if (this.resumenViajes == null) {
        this.resumenViajes = await ViajesGrupoApiService.getViajes();
      }
      return this.resumenViajes;
    },
    async fetchViajeSeleccionado(viajeId, codigoViaje = null, codigoPrevisualizacion = null) {
      if (this.viajeSeleccionado === null || this.viajeSeleccionado.id !== viajeId) {
        this.viajeSeleccionado = await ViajesGrupoApiService.getViaje(viajeId, codigoViaje, codigoPrevisualizacion);
      }
      return this.viajeSeleccionado;
    },
  },
});
